import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export const exportToExcel = (csvData: any, fileName: string, maxCharacters : Array<number>) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const ws = XLSX.utils.json_to_sheet(csvData);

  ws["!cols"] = [
    {width : 18},
    {width : 18},
    {wch : maxCharacters[2]},
    {wch : maxCharacters[3]},
    {wch : maxCharacters[4]},
    {wch : maxCharacters[5]},
    {wch : maxCharacters[6]},
    {wch : maxCharacters[7]},
    {wch : maxCharacters[8]},
    {width : 15},
    {width : 22},
    {wch : maxCharacters[9]},
  ]

  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};